import icon from './vue-flow-editor-icon.vue'

export const externalComponents = [
    icon,
]